import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OrderService } from '@app/services/order/order.service';
import { ToastService } from '@app/storybook/services/toast/toast.service';
import { TimeUnits } from '@utils/times-utils';
import moment from 'moment';

import { DeviceDetectorService } from 'ngx-device-detector';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-shipping-manifests-list',
  templateUrl: './shipping-manifests-list.component.html',
  styleUrls: ['./shipping-manifests-list.component.scss'],
  standalone: false,
})
export class ShippingManifestsListComponent implements OnInit {
  isTablet: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private deviceService: DeviceDetectorService,
    private orderService: OrderService,
    private toastService: ToastService,
  ) {
    this.isTablet = this.deviceService.isTablet();
  }
  rows = [];
  columns;
  isCreateMode = false;
  ngOnInit(): void {
    const columnWidth = this.isTablet ? 168 : 224;
    const minWidth = this.isTablet ? 154 : 224;
    const maxWidth = this.isTablet ? 190 : 264;
    this.columns = [
      {
        prop: 'displayProvider',
        name: 'Delivery Service',
        width: columnWidth,
        minWidth: minWidth,
        maxWidth: maxWidth,
        sortable: true,
      },
      {
        prop: 'displayPickupDate',
        name: 'Pickup date',
        width: columnWidth,
        minWidth: minWidth,
        maxWidth: maxWidth,
        sortable: true,
      },
      {
        prop: 'displayOrdersCount',
        name: 'Orders count',
        width: columnWidth,
        minWidth: minWidth,
        maxWidth: maxWidth,
        sortable: true,
      },
      {
        prop: 'shipFromAddress.storeName',
        name: 'Inventory location',
        width: columnWidth,
        minWidth: minWidth,
        maxWidth: maxWidth,
        sortable: true,
      },
      { prop: 'documents', name: '', sortable: false, width: 74, minWidth: 74, maxWidth: 74 },
    ];
    this.loadManifests();
  }

  createManifest(createMode) {
    this.isCreateMode = createMode;
    if (!createMode) {
      this.loadManifests();
    }
  }

  loadManifests() {
    this.orderService.loadManifests().subscribe((data) => {
      this.rows = data.map((row) => {
        row.displayProvider = row.provider.toUpperCase();
        row.displayPickupDate = moment.utc(row.pickupDate)?.format('ddd, MMM D, YYYY');
        row.displayOrdersCount = `${row.ordersCount} ${row.ordersCount === 1 ? 'order' : 'orders'}`;
        return row;
      });
    });
  }

  async downloadManifest(row) {
    if (row.documents?.length) {
      row.documents.map((document) => {
        window.open(document, '_blank');
      });
    } else {
      this.orderService
        .getManifestDocuments(row.orders[0]?.orderBatch?.selectedCarrier?.id, row.id, row.externalId)
        .pipe(
          catchError((error) => {
            this.toastService.showToast({
              mode: 'danger',
              message: `Unable to fetch document. Please contact PDQ support for assistance.`,
              duration: TimeUnits._SECOND_IN_MS * 5,
            });
            return of({ error: error });
          }),
        )
        .subscribe((data) => {
          if (data?.type === 'base64' || data?.documents?.length > 5000) {
            this.openPdfInNewTab(data.documents);
          } else if (data?.documents) {
            data.documents.map((document) => {
              window.open(document, '_blank');
            });
          }
        });
    }
  }

  openPdfInNewTab(base64String: string) {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(blob);

    const newTab = window.open(pdfUrl, '_blank');
    if (!newTab) {
      console.error('Pop-up blocked. Please allow pop-ups for this website.');
    }
  }
}
